export const create = (msg, code, payload) => {
    const error = new Error(msg);

    error.code = code;
    error.details = { payload: JSON.stringify(payload) };

    return error;
};

export const send = (errorToReport, fallbackCode = '', payload = {}) => {
    let error;

    if (errorToReport instanceof Error) {
        error = errorToReport;
    } else {
        error = create(errorToReport, fallbackCode, payload);
    }

    if (!error.code) {
        error.code = fallbackCode;
        error.details = { payload: JSON.stringify(payload) };
    }

    error.details.package = '@fiverr-private/attachments_preview';

    setTimeout(() => {
        throw error;
    });
};
